export default __webpack_public_path__ + "static/media/docIcon.f1ff5a3c.svg";